<template>
  <div :class="{'is-active': mobileVisible}">
    <slot/>

    <hr class="navbar-divider is-hidden-dektop" v-if="!$user.loading">

    <navbar-dropdown class="navbar-item is-small" v-if="$user.authenticated">
      <div class="navbar-link is-hidden-touch">
        <b-icon icon="user-circle-o"/>
      </div>
      <div class="navbar-dropdown">
        <a class="navbar-item" href="/admin" v-if="$user.isAdmin">
          Administration
        </a>

        <a class="navbar-item" href="/my-shopping-list">
          Meine Einkaufsliste
        </a>

        <a class="navbar-item" href="/my-account">
          Mein Account
        </a>

        <a class="navbar-item" @click="$user.logout(false)">
          <b-icon icon="sign-out"/> Abmelden
        </a>
      </div>
    </navbar-dropdown>

    <template v-else-if="!$user.loading">
      <language-select/>
      <a class="navbar-item is-narrow" href="/login">{{ $t('sign in') }}</a>
      <a class="navbar-item is-narrow" href="/login#/register">{{ $t('sign up') }}</a>
    </template>
  </div>
</template>

<script>
import NavbarDropdown from '../../NavbarDropdown.vue'
import LanguageSelect from '../../LanguageSelect.vue'

export default {
  data(){
    return this.$parent._data
  },

  components: {
    NavbarDropdown,
    LanguageSelect
  }
}
</script>

<i18n>
{
  "de_at": {
    "sign in": "Anmelden",
    "sign up": "Registrieren"
  },
  "cs": {
    "sign in": "přihlásit se",
    "sign up": "Registrovat"
  },
  "hu": {
    "sign in": "Bejelentkezés",
    "sign up": "regisztrálj"
  },
  "fr": {
    "sign in": "se connecter",
    "sign up": "s'inscrire"
  }
}
</i18n>

<style>

</style>



// WEBPACK FOOTER //
// src/components/frontend/menu/Navbar.vue